// Code generated by tools/capgen; DO NOT EDIT.
// Source of truth: capabilities/manifests/*.capabilities.json

export const Caps = {
  IdentityAccess: "identity:access",
  IdentityUsersView: "identity:users.view",
  IdentityUsersManage: "identity:users.manage",
  IdentityRolesView: "identity:roles.view",
  IdentityRolesManage: "identity:roles.manage",
  IdentityAuditView: "identity:audit.view",
  PlatformAccess: "platform:access",
  PlatformObservabilityView: "platform:observability.view",
  PlatformFleetView: "platform:fleet.view",
  PlatformFleetManage: "platform:fleet.manage",
  TelephonyCallsOriginate: "telephony:calls.originate",
  TelephonyCallsHold: "telephony:calls.hold",
  TelephonyCallsTransfer: "telephony:calls.transfer",
  TelephonyCallsHangup: "telephony:calls.hangup",
  TelephonyCallsClassify: "telephony:calls.classify",
  TelephonyMonitorView: "telephony:monitor.view",
  TelephonyMonitorListen: "telephony:monitor.listen",
  TelephonyMonitorWhisper: "telephony:monitor.whisper",
  TelephonyMonitorBarge: "telephony:monitor.barge",
  TelephonyHistoryView: "telephony:history.view",
  TelephonyRecordingsPlay: "telephony:recordings.play",
  TelephonyRecordingsExport: "telephony:recordings.export",
  TelephonyTranscriptsView: "telephony:transcripts.view",
  TelephonyAgentsManage: "telephony:agents.manage",
  TelephonyQueuesManage: "telephony:queues.manage",
  TelephonyClientsView: "telephony:clients.view",
  TelephonyClientsManage: "telephony:clients.manage",
  TelephonySettingsManage: "telephony:settings.manage",
  TelephonyAgentsStatusSelf: "telephony:agents.status.self",
} as const;

export type Cap = (typeof Caps)[keyof typeof Caps];

export interface CapabilityDef {
  key: string;
  app: string;
  label: string;
  group: string;
  implies: string[];
}

export interface TemplateDef {
  key: string;
  label: string;
  capabilities: string[];
}

export interface CapabilityCatalog {
  apps: string[];
  capabilities: CapabilityDef[];
  templates: TemplateDef[];
}

export const catalog: CapabilityCatalog = {
  apps: ["identity", "platform", "telephony"],
  capabilities: [
    { key: "identity:access", app: "identity", label: "Access the admin console", group: "Access", implies: [] },
    { key: "identity:users.view", app: "identity", label: "View users", group: "Users", implies: [] },
    { key: "identity:users.manage", app: "identity", label: "Create / edit / disable users", group: "Users", implies: ["identity:users.view"] },
    { key: "identity:roles.view", app: "identity", label: "View role templates", group: "Access control", implies: [] },
    { key: "identity:roles.manage", app: "identity", label: "Edit role templates & capability assignments", group: "Access control", implies: ["identity:roles.view"] },
    { key: "identity:audit.view", app: "identity", label: "View the audit log", group: "Audit", implies: [] },
    { key: "platform:access", app: "platform", label: "Access the platform", group: "Access", implies: [] },
    { key: "platform:observability.view", app: "platform", label: "View observability dashboards", group: "Observability", implies: [] },
    { key: "platform:fleet.view", app: "platform", label: "View fleet status", group: "Fleet", implies: [] },
    { key: "platform:fleet.manage", app: "platform", label: "Manage fleet (upgrades, licensing)", group: "Fleet", implies: ["platform:fleet.view"] },
    { key: "telephony:calls.originate", app: "telephony", label: "Place calls via the API", group: "Calls", implies: [] },
    { key: "telephony:calls.hold", app: "telephony", label: "Hold / unhold calls", group: "Calls", implies: [] },
    { key: "telephony:calls.transfer", app: "telephony", label: "Transfer calls (blind + attended)", group: "Calls", implies: [] },
    { key: "telephony:calls.hangup", app: "telephony", label: "Hang up calls", group: "Calls", implies: [] },
    { key: "telephony:calls.classify", app: "telephony", label: "Set a call's call type", group: "Calls", implies: [] },
    { key: "telephony:monitor.view", app: "telephony", label: "Monitor — View active calls", group: "Monitoring", implies: [] },
    { key: "telephony:monitor.listen", app: "telephony", label: "Monitor — Listen", group: "Monitoring", implies: ["telephony:monitor.view"] },
    { key: "telephony:monitor.whisper", app: "telephony", label: "Monitor — Whisper", group: "Monitoring", implies: ["telephony:monitor.listen", "telephony:monitor.view"] },
    { key: "telephony:monitor.barge", app: "telephony", label: "Monitor — Barge", group: "Monitoring", implies: ["telephony:monitor.whisper", "telephony:monitor.listen", "telephony:monitor.view"] },
    { key: "telephony:history.view", app: "telephony", label: "History — View call history & metrics", group: "History", implies: [] },
    { key: "telephony:recordings.play", app: "telephony", label: "History — Play call recordings", group: "History", implies: ["telephony:history.view"] },
    { key: "telephony:recordings.export", app: "telephony", label: "History — Download recordings", group: "History", implies: ["telephony:recordings.play", "telephony:history.view"] },
    { key: "telephony:transcripts.view", app: "telephony", label: "History — View call transcripts", group: "History", implies: ["telephony:history.view"] },
    { key: "telephony:agents.manage", app: "telephony", label: "Manage agents", group: "Provisioning", implies: [] },
    { key: "telephony:queues.manage", app: "telephony", label: "Manage queues & membership", group: "Provisioning", implies: [] },
    { key: "telephony:clients.view", app: "telephony", label: "See client name & greeting on calls", group: "Provisioning", implies: [] },
    { key: "telephony:clients.manage", app: "telephony", label: "Manage clients & their DIDs", group: "Provisioning", implies: ["telephony:clients.view"] },
    { key: "telephony:settings.manage", app: "telephony", label: "Manage telephony settings (hold music, …)", group: "Provisioning", implies: [] },
    { key: "telephony:agents.status.self", app: "telephony", label: "Set my own agent status", group: "Provisioning", implies: [] },
  ],
  templates: [
    { key: "identity-viewer", label: "Identity — Viewer", capabilities: ["identity:access", "identity:users.view", "identity:audit.view"] },
    { key: "identity-admin", label: "Identity — Admin", capabilities: ["identity:access", "identity:users.manage", "identity:roles.manage", "identity:audit.view"] },
    { key: "platform-operator", label: "Platform — Operator", capabilities: ["platform:access", "platform:observability.view", "platform:fleet.manage"] },
    { key: "telephony-agent", label: "Telephony — Agent", capabilities: ["telephony:calls.originate", "telephony:calls.hold", "telephony:calls.transfer", "telephony:calls.hangup", "telephony:agents.status.self", "telephony:clients.view", "telephony:calls.classify"] },
    { key: "telephony-supervisor", label: "Telephony — Supervisor", capabilities: ["telephony:calls.originate", "telephony:calls.hold", "telephony:calls.transfer", "telephony:calls.hangup", "telephony:monitor.barge", "telephony:recordings.play", "telephony:transcripts.view", "telephony:clients.view", "telephony:calls.classify"] },
    { key: "telephony-admin", label: "Telephony — Admin", capabilities: ["telephony:agents.manage", "telephony:queues.manage", "telephony:clients.manage", "telephony:settings.manage", "telephony:monitor.barge", "telephony:recordings.export", "telephony:transcripts.view", "telephony:calls.originate", "telephony:calls.hold", "telephony:calls.transfer", "telephony:calls.hangup"] },
  ],
};
